import { Box } from "@mui/material"

const validateDataTable = (data) => {

    const response = []

    if (data?.grupo_filial.length === 0)
        response.push(<Box>Selecione um grupo filial.</Box>)
 
    if (!data?.nome > 0)
        response.push(<Box>Digite um nome.</Box>)

    if (data?.id_tipo.length === 0)
        response.push(<Box>Selecione um tipo.</Box>)

    if (!data?.data_fim)
        response.push(<Box>Digite a data fim.</Box>)

    if (!data?.desconto_valor_avista)
        response.push(<Box>Digite o desconto à vista.</Box>)

    if (!data?.preco_minimo > 0)
        response.push(<Box>Digite o preço mínimo.</Box>)
    
    if (response.length === 0)
        return ''

    return (response)
}

export default validateDataTable